import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import ButtonComponent from '@prisjakt/ui-button';
import PriceLabelComponent from '@prisjakt/ui-price-label';
import ProductImageComponent from '@prisjakt/ui-product-image';
import StockStatusComponent from '@prisjakt/ui-stock-status';
import StockStatusColumnComponent from '../../stock-status-column';
import FeedbackButtonComponent from '../../../../../areas/feedback/feedback-button';

const sharedMarginStyles = css`
  margin-bottom: ${layout.spacing.xSmall};
`;

const CardMargin = '23px';
const productImageSize = '48px';
const buttonMaxWidth = '210px';
const priceLabelFontSize = '20px';
const submitMessageHeight = '150px';
const reportDescriptionWidth = '450px';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  max-width: 100%;
  align-items: center;
  margin-bottom: ${CardMargin};
`;

export const Button = styled(ButtonComponent)`
  width: 100%;
  max-width: ${buttonMaxWidth};

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

export const FeedbackButton = styled(FeedbackButtonComponent)`
  width: 100%;
  max-width: ${buttonMaxWidth};
`;

export const Title = styled.h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  svg {
    margin-right: 10px;
  }
`;

export const ProductImage = styled(ProductImageComponent)`
  width: ${productImageSize};
  ${sharedMarginStyles};
`;

export const ProductName = styled.span`
  ${sharedMarginStyles};
`;

type ReportDescriptionProps = {
  thin?: boolean;
};

export const ReportDescription = styled.span<ReportDescriptionProps>`
  ${sharedMarginStyles};
  text-align: center;
  max-width: ${reportDescriptionWidth};

  ${props =>
    props.thin &&
    css`
      color: ${p => p.theme.text.tertiary};
      font-size: ${layout.fontSizes.small.mobile.rem};
    `}
`;

export const PriceLabel = styled(PriceLabelComponent)`
  ${sharedMarginStyles};
  font-size: ${priceLabelFontSize};
`;

export const StockStatusColumn = styled(StockStatusColumnComponent)`
  ${sharedMarginStyles};
`;

export const SubmitMessage = styled.div`
  min-height: ${submitMessageHeight};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    margin-bottom: ${layout.spacing.small};
  }
`;

export const ButtonText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StockStatus = styled(StockStatusComponent)`
  ${sharedMarginStyles};
`;
